import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {ReportGeneratorService} from '../../services/report-generator.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: 'report-generator.component.html',
})
export class ReportGeneratorComponent implements OnInit, OnDestroy {

    constructor(public reportGeneratorService: ReportGeneratorService,
                public urlService: UrlService) {
    }

    ngOnInit() {
        this.reportGeneratorService.turnComponent('isListShow');
        this.reportGeneratorService.getBuildings();

        this.urlService.onUrlChange
            .pipe(
                tap(() => this.reportGeneratorService.tabId = this.urlService.queryParams['tab']),
                tap(() => clearInterval(this.reportGeneratorService.refreshInterval)),
                tap(() => {
                    if (this.reportGeneratorService.tabId == 'allReports') { // @todo needs refactor
                        this.reportGeneratorService.refreshInterval = setInterval(() => {
                            if (this.reportGeneratorService.data.allReports.data && this.reportGeneratorService.data.allReports.data.length > 0) {
                                this.reportGeneratorService.data.allReports.data.forEach(report => {
                                    if (report.status === 'in_progress' || report.status === 'wait')
                                        this.reportGeneratorService.getReport(report.id);
                                });
                            }
                        }, 10000);
                    }
                }),
                flatMap(
                    () => this.reportGeneratorService.getDataByQueryParams()
                        .pipe(
                            takeUntil(this.urlService.instantOnUrlChange)
                        )
                )
            )
            .subscribe();
        this.urlService.setQueryParams(this.reportGeneratorService.tabId);
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.reportGeneratorService.resetData();
        this.urlService.resetQueryParams();
        clearInterval(this.reportGeneratorService.refreshInterval);
    }

    removeAllObservers() {
        this.urlService.onUrlChange.observers = [];
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.reportGeneratorService.emptyRowService.fillEmptyRow();
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/report-generator/report-generator.component.ts